import { ReleaseComponentPage } from '@features/catalog';
import { Navigate, useParams } from 'react-router';

/** `/catalog/components/release/:id`. Thin, like `FlagDetailRoute`: the screen lives in the feature. */
export function ReleaseComponentRoute() {
    const { id } = useParams<{ id: string }>();

    if (!id) return <Navigate to="/catalog/components" replace />;

    return <ReleaseComponentPage id={id} />;
}
